import React from 'react';
import PropTypes from 'prop-types';
import PhotoCard from 'Core/Components/PhotoCard';

class RecentBlogPosts extends React.Component {
  constructor (props) {
    super(props);
    const { id, getBlogPosts } = props;
    this.state = { posts: getBlogPosts(id) }
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    const { getBlogPosts, store } = this.props;
    this.unsubscribe = store.subscribe(() => {
      const { id } = this.props;
      this.setState({ posts: getBlogPosts(id) });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  render () {
    const { id, limit, activePostSlug } = this.props;
    const { posts: unsortedPosts } = this.state;

    const posts = unsortedPosts
      .filter(({ slug }) => slug !== activePostSlug)

    return !posts || !posts.length
      ? (
        <row>
          <p style={{ margin: '40px auto', fontStyle: 'italic' }}>
            The blog <b>{id}</b> couldn't be found.
          </p>
        </row>
      ) : (
      <row>
        {posts.reverse().map((card, index) => {
          card.subtitle = 'From The Blog';
          card.url = `/${id}/${card.slug}`;
          return !limit || index < limit
            ? <PhotoCard key={card.title} card={card} />
            : null;
        })}
      </row>
    );
  }
};

RecentBlogPosts.propTypes = {
  id: PropTypes.string,
  store: PropTypes.object,
  getBlogPosts: PropTypes.func
};

export default RecentBlogPosts;



// WEBPACK FOOTER //
// ./client/Site/Ui/RecentBlogPosts.jsx